import React from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { resolveCapabilityModeIcon } from './capabilityIcons.jsx';

function ModeFeedback({ loading, error, refresh }) {
  return <>
      {loading ? <div aria-busy="true" className="flare-skill-management-state">加载中…</div> : null}
      {error ? (
        <div className="flare-skill-management-error" role="alert">
          <span>{String(error.message || error)}</span>
          <button aria-label="重试模式" className="flare-skill-icon-button" onClick={() => void refresh?.(true).catch?.(() => {})} type="button">
            <ReloadOutlined />
          </button>
        </div>
      ) : null}
  </>;
}

export default function ModeManagementPanel({ modeManagement = {}, viewMode = 'list' }) {
  const { projection = {}, loading = false, error, refresh, toggle, updatingModeId = '' } = modeManagement;
  const modes = Array.isArray(projection.modes) ? projection.modes : [];
  return (
    <section aria-label="模式" className="flare-mode-management">
      <header className="flare-skill-management-header">
        <h2>模式</h2>
        <div className="flare-skill-management-controls">
          <span className="flare-skill-management-count">{modes.length} 个模式</span>
        </div>
      </header>
      <ModeFeedback loading={loading} error={error} refresh={refresh} />
      <div className={`flare-skill-management-list is-${viewMode}`}>
        {modes.map((item) => (
          <div className="flare-mode-management-row" key={item.target_id}>
            <span aria-hidden="true" className="flare-skill-management-icon flare-mode-management-icon">{resolveCapabilityModeIcon(item.target_id)}</span>
            <span className="flare-skill-management-copy">
              <span className="flare-skill-management-name">{item.label}</span>
              {item.description ? (
                <span className="flare-skill-management-meta">{item.description}</span>
              ) : null}
            </span>
            <button
              aria-label={`${item.label}${item.enabled ? '已启用' : '已停用'}`}
              aria-checked={item.enabled === true}
              className={`flare-skill-toggle${item.enabled ? ' is-enabled' : ''}`}
              disabled={!item.manageable || Boolean(updatingModeId)}
              onClick={() => void toggle?.(item)?.catch?.(() => {})}
              role="switch"
              type="button"
            ><span /></button>
          </div>
        ))}
      </div>
    </section>
  );
}
